// types
import { IStep, IStepExtended } from '../types';
import { IFormSection, IManifestFieldHydrated } from '../../../manifests/types';

export const sectionsToSteps = (
    sections: IFormSection<IManifestFieldHydrated>[],
    t: (key: string, options: any) => string
): IStep[] =>
    sections.map(
        ({ name, group, manifest, skipReview, collapsedOnReview, reviewSectionPillKey, reviewStepOnly }, index) => ({
            label: group ? t(group, { ns: 'formSections' }) : name ?? 'General',
            questions: manifest.map(({ id }) => id),
            skipReview,
            reviewStepOnly,
            collapsedOnReview,
            reviewSectionPillKey
        })
    );

export const consolidateSteps = (steps: IStep[]): IStepExtended[] =>
    steps.reduce<IStepExtended[]>((acc, curr, index) => {
        const last = acc?.[acc.length - 1];

        if (last && curr.label === last?.label) {
            return [
                ...acc.slice(0, -1),
                {
                    ...last,
                    substeps: curr?.reviewStepOnly ? last.substeps : [...last.substeps, index],
                    questions: [...(last?.questions ?? []), ...(curr?.questions ?? [])]
                }
            ];
        } else {
            return [...acc, { ...curr, substeps: [index] }];
        }
    }, []);

export const sectionsToConsolidatedSteps = (
    sections: IFormSection<IManifestFieldHydrated>[],
    t: (key: string, options: any) => string
): IStepExtended[] => {
    const steps = sectionsToSteps(sections, t);

    return consolidateSteps(steps);
};
